// extracted by mini-css-extract-plugin
export default {"Disabled":"SubmitButton_Disabled__z9A7g","Button":"SubmitButton_Button__DV7L2","Primary":"SubmitButton_Primary__X5UwO","Secondary":"SubmitButton_Secondary__dn2yx"};